import { render, staticRenderFns } from "./IncomeStatement.vue?vue&type=template&id=1796bca4&scoped=true"
import script from "./IncomeStatement.vue?vue&type=script&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&lang=js"
import style0 from "./IncomeStatement.vue?vue&type=style&index=0&id=1796bca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796bca4",
  null
  
)

export default component.exports